<template>
  <div class="ts-space-y-2">
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('department.nameKh') }}</label>
        <input
          v-model="model.location_name_kh"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('location_name_kh') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('location_name_kh')"
        >
          {{ errors.first('location_name_kh') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{ $t('department.nameEn') }}</label>
        <input
          v-model="model.location_name_en"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('location_name_en') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('location_name_en')"
        >
          {{ errors.first('location_name_en') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label>{{ $t('warehourse.saleType') }}</label>
        <a-select
          style="width: 100%; font-size: 15px"
          allowClear
          v-model="model.sale_type"
          :options="posType"
          placeholder="All"
        ></a-select>
        <div class="validate" v-if="errors.has('sale_type')">
          {{ errors.first('sale_type') }}
        
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <ts-checkbox v-model="model.is_main_warehouse">{{
          $t('warehourse.isMain')
        }}</ts-checkbox>
        <ts-checkbox v-model="model.is_transfer_approval_one_time">{{
          $t('warehourse.isTransferApprovalOneTime')
        }}</ts-checkbox>
        <div class="validate ts-text-xs" v-if="errors.has('is_main_warehouse')">
          {{ errors.first('is_main_warehouse') }}
        </div>
        <ts-checkbox v-model="model.dashboard_stock_tracking">
          {{ $t('productProfile.dashboardStockTracking') }}
        </ts-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-mt-3 text-right">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          v-if="!isUpdate"
          color="primary"
          @click.prevent="onSave"
          :waiting="waiting"
          >{{ $t('save') }}</ts-button
        >
        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
          >{{ $t('update') }}</ts-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'warehourseForm',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      model: {
        location_id: 0,
        location_name_kh: null,
        location_name_en: null,
        is_main_warehouse: false,
        dashboard_stock_tracking: false,
        is_transfer_approval_one_time: false,
        sale_type: ''
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('stock/warehourse', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    },
    posType() {
      return [
        { value: 'Retail', label: 'Retail Sale' },
        { value: 'Wholesale', label: 'Whole Sale' }
      ]
    }
  },
  methods: {
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('stock/warehourse/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('stock/warehourse/update', {
          id: this.model.location_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.location_id = this.edit_data.location_id
        this.model.location_name_kh = this.edit_data.location_name_kh
        this.model.location_name_en = this.edit_data.location_name_en
        this.model.is_main_warehouse = this.edit_data.is_main_warehouse
        this.model.dashboard_stock_tracking = this.edit_data.dashboard_stock_tracking
        this.model.is_transfer_approval_one_time = this.edit_data.is_transfer_approval_one_time
      }
    }
  }
}
</script>
